<template>
  <div class="signup-email">
    <div class="alert" v-if="showEmailVerificationFailure">
      <ul><li>登録用URLが有効ではありません。下記より再登録をお願いします。</li></ul>
    </div>

    <div class="banner" v-if="isLightTrial">
      <img src="@/assets/trial_banner.png">
    </div>

    <p class="title">
      3分でカンタン登録<br>
      {{isCampaignTrial ? '英会話カフェ生活' : (isLightTrial ? 'トライアル入会' : '無料体験')}}をはじめよう！
    </p>

    <Form v-slot="{meta, errors}" @submit="() => {}">
      <Input
        name="emailAddress"
        v-model="emailAddress"
        type="text"
        as="input"
        rules="email"
        label="メールアドレス"
        :display-error="(!meta.valid && meta.touched && errors['emailAddress'] !== undefined) || (meta.valid && backendErrorMessage !== '')"
        :error-message="backendErrorMessage || 'メールアドレスを正しく入力してください'"
      />

      <div class="button-container">
        <Button @click="submit(meta.valid)" color="gold" :is-invalid="!meta.valid">
          {{isCampaignTrial ? 'キャンペーンで登録する' : (isLightTrial ? '会員登録をする（無料）' : '登録する(無料)') }}
        </Button>
      </div>
    </Form>

    <p class="terms-agreement">
      登録することで<a href="https://lancul.com/terms" target="_blank">利用規約</a>に同意したものとなります。
    </p>

    <div class="links">
      <div class="link">
        <a href="/">すでにアカウントをお持ちの方</a>
      </div>
      <div class="line" />
      
      <div class="link">
        <a href="https://my-lancul.com/members/password/remind/mail">パスワードをお忘れの方</a>
      </div>
      <div class="link">
        <a href="https://my-lancul.com/members/password/remind/id/">メールアドレスをお忘れの方</a>
      </div>
      <div class="line" />

      <div class="link">
        <a href="https://trial.lancul.com">LanCulを初めて利用される方</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Form } from 'vee-validate';
import Input from '@/components/signup/Input.vue'
import Button from '@/components/signup/Button.vue'

export default {
  name: 'Email',

  components: {
    Form,
    Input,
    Button
  },

  data() {
    return {
      emailAddress: ''
    }
  },

  props: {
    showEmailVerificationFailure: {
      type: Boolean,
      required: true
    },

    backendErrorMessage: {
      type: String,
      required: true
    },

    isCampaignTrial: {
      type: Boolean,
      required: true
    },

    isLightTrial: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    submit(valid) {
      if (valid) {
        this.$emit('submit', this.emailAddress)
      }
    }
  }
}
</script>

<style scoped>
.signup-email .alert {
  background-color: #fff;
  margin-bottom: 84px;
  padding: 17px 20px;
  border: 1px solid #EE001D;
  box-sizing: border-box;
}

.signup-email .alert ul {
  padding-left: 20px;
}

.signup-email .alert ul li {
  list-style-type: square;
  color: red;
}

.signup-email p.title {
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  text-align: center;
  color: black;
  margin-bottom: 40px;
}

.signup-email .button-container {
  margin-top: 20px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.signup-email p.terms-agreement {
  font-size: 12px;
  line-height: 18px;
  color: #333;
}

.signup-email .links {
  margin-top: 40px;
}

.signup-email .link {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.signup-email .link a {
  color: #999;
  font-size: 12px;
  line-height: 18px;
}

.signup-email .line {
  height: 1px;
  background-color: #B6B6B6;
  opacity: 0.5;
}

.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.banner img {
  width: 100%;
}

@media (max-width: 425px) {
  .signup-email .button-container {
    margin-top: 28px;
  }
}
</style>
